// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"0996bb61","156":"28cc8068","165":"293cb81d","400":"3bf26a18","407":"2274707b"}[chunkId] + ".chunk.js";
};